import { FC } from 'react';
import { useHistory } from 'react-router';
import { RadabankOnboardingContent } from 'components/RadabankCard';
import { ArrowBackButton, CustomButton } from 'components/shared';
import { FIREBASE_EVENT_ANALYTICS_BUTTON, FIREBASE_EVENT_ANALYTICS_PAGE } from 'utils/constants';
import { ROUTER_URL } from 'utils/enums';
import { useGoBackRadabank } from 'utils/hooks';
import { FirebaseAnalytics } from 'utils/services';

export const RadabankCardOverdraftRequestBanner: FC = () => {
	const history = useHistory();

	const handleClickBack = useGoBackRadabank();

	const handleClickRedirectMain = () => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.CARD_OVERDRAFT_BANNER,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_HOME
		);
		history.push(ROUTER_URL.RADABANK_CARD);
	};

	const handleGoBack = () => {
		FirebaseAnalytics.logEvent(
			FIREBASE_EVENT_ANALYTICS_PAGE.RADABANK.CARD_OVERDRAFT_BANNER,
			FIREBASE_EVENT_ANALYTICS_BUTTON.GO_BACK
		);
		handleClickBack();
	};

	return (
		<div className="host-card-page-color-primary">
			<ArrowBackButton onClick={handleGoBack} color="white" />
			<RadabankOnboardingContent
				title="Заявку відправлено!"
				description={['Ви отримаєте повідомлення про рішення банку щодо зміни ліміту']}
			/>
			<CustomButton label="На головну" color="secondary" onClick={handleClickRedirectMain} />
		</div>
	);
};
